<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar dense color="secondary" elevation="1" rounded>
                    <v-breadcrumbs class="ms-n6" :items="breadcrumbsItems" large/>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-sheet elevation="1" rounded>
                    <v-toolbar flat color="secondary">
                        <v-toolbar-title>
                            Warehouse
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <PIconBtn icon="mdi-pencil" tooltip="Edit" @click="navigateToEdit" v-if="hasPermission(perm.warehouse.update)"/>
                            <PIconBtn icon="mdi-format-list-text" tooltip="List" @click="navigateToList" v-if="hasPermission(perm.warehouse.index)"/>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <Warehouse :value="data" v-if="!loading"/>
                    <WarehouseLoader v-else/>
                </v-sheet>  
            </v-col>
        </v-row>
        <!-- <v-row>
            <v-col>
                <v-sheet elevation="1" rounded>
                    <v-toolbar flat color="secondary">
                        <v-toolbar-title>Warehouse Items</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn text @click="handleCreateWarehouseItem">
                                <v-icon left>mdi-plus</v-icon>
                                attach item
                            </v-btn>
                            <v-btn depressed color="primary" @click="handleSearch">
                                <v-icon left>mdi-magnify</v-icon>
                                search
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <WarehouseItemList :warehouse-id="id"/>
                </v-sheet>
            </v-col>
        </v-row> -->
        <PAlert v-model="alert.value" v-bind="alert"/>
        <!-- <v-dialog v-model="searchDialogShown" max-width="350">
            <v-sheet>
                <v-toolbar dense flat>
                    <v-toolbar-title>
                        Search
                    </v-toolbar-title>
                </v-toolbar>
                <div class="pa-3">
                    <v-row>
                        <v-col>
                            <WarehouseItemListSearchForm v-model="searchForm"/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-btn block depressed color="primary" @click="search">
                                <v-icon left>mdi-magnify</v-icon>
                                search
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
            </v-sheet>
        </v-dialog> -->
    </v-container>
</template>

<script>
import Warehouse from './../../components/warehouse/Warehouse.vue'
import WarehouseLoader from './../../components/warehouse/WarehouseLoader';
// import WarehouseItemList from './../../components/warehouse/WarehouseItemList';
import PIconBtn from './../../components/common/PIconBtn.vue'
import PAlert from './../../components/common/PAlert.vue';
// import WarehouseItemListSearchForm from './../../components/warehouse/WarehouseItemListSearchForm';

import { mapActions, mapGetters } from 'vuex'
import permissions from './../../data/permissions';
export default {
    name: "WarehouseDisplayView",
    components: {
        PIconBtn,
        PAlert,
        Warehouse,
        WarehouseLoader,
        // WarehouseItemList,
        // WarehouseItemListSearchForm
    },
    data() {
        return {
            breadcrumbsItems: [
                {text: 'Warehouse & Inventory'},
                {text: 'Warehouse'},
                {text: "Display Warehouse"}
            ],
            id: null,
            data: null,
            loading: false,
            // searchDialogShown: false,
            // searchForm: null,
            alert: {
                value: false,
                title: "Alert",
                content: "Are you sure",
                callback: null
            },
            perm: permissions
        }
    },
    computed: {
        // ...mapGetters({
        //     warehouseItemParams: "stock/warehouseItem/list/params"
        // })
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            findByID: "warehouse/warehouse/findByID",
            // searchWarehouseItems: "stock/warehouseItem/list/updateParams",
            snackbar: "ui/snackbar/show"
        }),
        navigateToEdit() {
            this.$router.push({ name: "WarehouseEdit", params: { id: this.id }})
        },
        navigateToList() {
            this.$router.push({ name: "WarehouseList" })
        },
        getWarehouse() {
            this.loading = true
            this.findByID(this.id).then(response => {
            this.data = response.data 
            }).catch(error => {
            let message = error.response ? error.response.data.message : error
            this.snackbar({color: 'error', text: message })
            console.log(error)
            }).finally(() => {
                this.loading = false;
            })
        },
        // handleCreateWarehouseItem() {
        //     this.$router.push({ name: "WarehouseItemCreate", params: { warehouseId: this.id } })
        // },
        // handleSearch() {
        //     this.searchDialogShown = true;
        // },
        // search() {
        //     this.searchWarehouseItems({...this.searchForm, warehouse_id: this.warehouseItemParams.warehouse_id})
        // }
    },
    created() {
        this.id = this.$route.params.id;
        this.getWarehouse()
    },
    beforeRouteUpdate(to, from, next) {
        this.id = to.params.id;
        this.getWarehouse();
        next()
    }
}
</script>

<style>

</style>